<template>
  <v-card>
    <v-card-title class="headline">
      <strong class="headline"
        >Adição de previsão do orçamento (Notificação)
      </strong>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-0">
      <v-container grid-list-xl class="px-3 pt-3 pb-0">
        <v-layout row wrap justify-center align-center>
          <v-flex xs12 md4>
            <v-sheet color="purple darken-4" height="80" elevation="1" dark>
              <blockquote class="blockquote">
                <h3 class="text-truncate headline">
                  {{ ano_mes[1] + "/" + ano_mes[0] }}
                </h3>
                <h5 class="subheading">{{ nome_credor }}</h5>
              </blockquote>
            </v-sheet>
          </v-flex>
          <v-flex xs12 md4>
            <v-sheet
              color="deep-purple darken-4"
              height="80"
              elevation="1"
              dark
            >
              <blockquote class="blockquote">
                <h3 class="text-truncate headline">
                  {{ dates.length }}
                </h3>
                <h5 class="subheading">Dias de Produção</h5>
              </blockquote>
            </v-sheet>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container grid-list-md class="px-3 pt-2 pb-0">
        <v-layout row wrap justify-center align-center class="mb-4">
          <v-flex xs12>
            <div style="line-height: 16px">
              <h4 class="subheading">Acumulado do mês:</h4>
              <p class="grey--text text--darken-1">Antes do arredondamento</p>
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <v-card color="deep-purple lighten-5" class="elevation-0">
              <v-text-field
                readonly
                full-width
                hide-details
                type="text"
                label="Orçamento"
                :value="gasto_acumulado | numeral('$0,0.00')"
              />
            </v-card>
          </v-flex>
          <v-flex xs12 md3>
            <v-card color="deep-purple lighten-5" class="elevation-0">
              <v-text-field
                readonly
                full-width
                hide-details
                type="text"
                label="Produção"
                :value="producao_acumulada"
              />
            </v-card>
          </v-flex>
          <v-flex xs12 md3>
            <v-card color="deep-purple lighten-5" class="elevation-0">
              <v-text-field
                readonly
                full-width
                hide-details
                type="text"
                label="CPP"
                :value="cpp_acumulado | numeral('$0,0.00')"
              />
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center class="mt-2">
          <v-flex xs12>
            <div style="line-height: 16px">
              <h4 class="subheading">Previsão:</h4>
              <p class="grey--text text--darken-1">
                Estes valores ainda serão arredondados na divisão entre os dias,
                sendo a produção arredondada para cima
              </p>
            </div>
          </v-flex>
          <v-flex xs12 md10 d-flex align-center>
            <v-text-field
              box
              hide-details
              step="0.01"
              type="number"
              label="Orçamento"
              v-model="orcamento_estimado_mes"
            />
            <v-icon>mdi-division</v-icon>
            <v-text-field
              type="number"
              step="1"
              label="Produção"
              box
              hide-details
              v-model="producao_estimada_mes"
            />
            <v-icon>mdi-equal</v-icon>
            <v-text-field
              outline
              readonly
              hide-details
              type="text"
              label="CPP"
              style="max-width: 120px"
              :value="cpp_estimado | numeral('$0,0.00')"
            />
          </v-flex>
          <v-flex xs12 class="mt-4">
            <h4 class="subheading">Dividir entre os dias:</h4>
          </v-flex>
          <v-flex xs12>
            <v-date-picker
              multiple
              no-title
              full-width
              :min="min"
              :max="max"
              locale="br"
              prev-icon=""
              next-icon=""
              class="elevation-0 qj-date-picker"
              v-model="dates"
            ></v-date-picker>
          </v-flex>
          <v-flex xs12 style="display: flex">
            <v-spacer />
            <v-btn
              flat
              small
              class="ma-0"
              @click="all_days"
              color="pink accent-2"
            >
              Incluir todos os dias
            </v-btn>
            <v-btn
              flat
              small
              class="ma-0"
              @click="dates = []"
              color="pink accent-2"
            >
              Limpar dias
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider />
    <v-card-actions class="py-2">
      <v-btn flat color="primary accent-2" @click="closeDialog">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="gerar_orcamento" :disabled="esperar"
        >Salvar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: [
    "open",
    "ano_mes",
    "esperar",
    "total_gasto_mes",
    "total_producao_mes",
    "nome_credor",
  ],
  data() {
    return {
      dates: [],
      orcamento_estimado_mes: "",
      producao_estimada_mes: "",
    };
  },
  computed: {
    min() {
      let min = this.ano_mes[0] + "-";
      if (this.ano_mes[1] > 10) min += "0" + this.ano_mes[1];
      else min += this.ano_mes[1];
      min += "-0" + 1;
      return min;
    },
    max() {
      let max = this.ano_mes[0] + "-";
      if (this.ano_mes[1] > 12) max += "0" + this.ano_mes[1];
      else max += this.ano_mes[1];
      max += "-" + this.dias_mes;
      return max;
    },
    dias_mes() {
      return new Date(this.ano_mes[0], this.ano_mes[1], "0").getDate();
    },
    cpp_estimado() {
      const cpp =
        parseFloat(this.orcamento_estimado_mes) /
        parseInt(this.producao_estimada_mes);

      if (isFinite(cpp)) {
        return cpp;
      } else {
        return 0;
      }
    },
    producao_acumulada() {
      if (
        isNaN(this.producao_estimada_mes) ||
        this.producao_estimada_mes == ""
      ) {
        return parseInt(this.total_producao_mes);
      }

      return (
        parseInt(this.producao_estimada_mes) + parseInt(this.total_producao_mes)
      );
    },
    gasto_acumulado() {
      if (
        isNaN(this.orcamento_estimado_mes) ||
        this.orcamento_estimado_mes == ""
      ) {
        return parseFloat(this.total_gasto_mes);
      }

      return (
        parseFloat(this.total_gasto_mes) +
        parseFloat(this.orcamento_estimado_mes)
      );
    },
    cpp_acumulado() {
      return this.gasto_acumulado / this.producao_acumulada;
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.dates = [];
        let anoMes = this.ano_mes.join("-") + "-";
        let newDates = [];
        for (let dia = 1; dia <= this.dias_mes; dia++) {
          var dia_considerado = new Date(
            this.ano_mes[0],
            this.ano_mes[1] - 1,
            dia
          ).getDay();
          if (dia_considerado != 0 && dia_considerado != 6) {
            newDates.push(anoMes + (dia < 10 ? "0" + dia : dia));
          }
        }
        setTimeout(() => (this.dates = newDates));
      }
    },
    ano_mes: function (novo, velho) {
      this.estado_inicial();
    },
    nome_credor: function (novo, velho) {
      this.estado_inicial();
    },
  },
  methods: {
    estado_inicial() {
      this.orcamento_estimado_mes = "";
      this.producao_estimada_mes = "";
    },
    gerar_orcamento() {
      const lista_mes = this.gerar_dias();
      const recursos_dia = (
        parseFloat(this.orcamento_estimado_mes) / lista_mes.length
      ).toFixed(2);
      const producao_dia = Math.round(
        this.producao_estimada_mes / lista_mes.length
      );

      if (isNaN(recursos_dia) || isNaN(producao_dia)) {
        this.$store.commit(
          "showSnackbar",
          "verifique seus dados, valores inválidos!"
        );
      } else {
        lista_mes.map((d) => {
          d.goal = producao_dia;
          d.budget = recursos_dia;
        });

        this.$emit("salvar", lista_mes);
        this.estado_inicial();
      }
    },
    gerar_dias() {
      var lista = [];
      var dia_considerado = new Date(
        this.ano_mes[0],
        this.ano_mes[1] - 1,
        this.dates[0].split("-")[2]
      );

      this.dates.forEach((date) => {
        lista.push({
          dia_semana: dia_considerado.getDay(),
          dia: date.split("-")[2],
          goal: 0,
          budget: 0,
        });
        dia_considerado.setDate(dia_considerado.getDate() + 1);
      });

      return lista;
    },
    closeDialog() {
      this.$emit("closeDialog");
      this.estado_inicial();
    },
    all_days() {
      let anoMes = this.ano_mes.join("-") + "-";
      let newDates = [];
      for (let dia = 1; dia <= this.dias_mes; dia++) {
        newDates.push(anoMes + (dia < 10 ? "0" + dia : dia));
      }
      this.dates = newDates;
    },
  },
};
</script>

<style>
.qj-date-picker td {
  padding: 0;
}
</style>
